import { ROUNDING_MODE } from "../utils/Constant";
const DEFAULT_ROUNDING_MODE = ROUNDING_MODE.ROUND;

export const dateFormatter = (date, locale) => {
  return new Intl.DateTimeFormat(locale).format(date);
};
export const numberFormatter = (
  number = 0,
  locale = window.locale?.defaultLocale,
  decimals = 2,
  roundingRule = DEFAULT_ROUNDING_MODE
) => {
  roundingRule(number);
  return parseFloat(number).toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const intlNumberFormatter = (number, decimals = 2, locale = window.locale?.defaultLocale) => {
  if (typeof number !== "number" || isNaN(number) || number === undefined) {
    // Handling cases where number is not a valid number
    return "--";
  }

  return new Intl.NumberFormat(locale).format(number.toFixed(decimals));
};
export const getInternationalFormatNumber = (key, currency, locale = window.locale?.defaultLocale) => {
  if (typeof key !== "number" || isNaN(key)) {
    // Handling cases where number is not a valid number
    return "--";
  }

  if (!key && key !== 0) return "--";

  const formattedKey = key.toLocaleString(locale);
  if (key < 0 && currency) {
    let num = Math.abs(key).toLocaleString(locale);
    let roundedNumer = `- ${currency}${num}`;
    return roundedNumer;
  }

  if (currency) {
    let roundedNumer = `${currency}${formattedKey}`;
    return roundedNumer;
  } else {
    let roundedNumer = formattedKey;
    return roundedNumer;
  }
};
export const intlNumberFormatterZero = (number = 0, decimals = 2, locale = window.locale?.defaultLocale) => {
  // Handle the case where number is very close to zero (negative or positive)
  if (Math.abs(number) < 1e-10) {
    return new Intl.NumberFormat(locale).format(0); // Format it as 0
  }

  return new Intl.NumberFormat(locale).format(number.toFixed(decimals));
};

export const intlNumberFormatterInK = (number = 0, decimals = 0, locale = window.locale?.defaultLocale) => {
  if (typeof number !== "number" || isNaN(number)) {
    return "--";
  }

  if (Math.abs(number) >= 1000000000) {
    const abbreviatedNumber = (number / 1000000000).toFixed(2);
    const formattedNumber = new Intl.NumberFormat(locale, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(Number(abbreviatedNumber));
    return `${formattedNumber}B`;
  } else if (Math.abs(number) >= 1000000) {
    const abbreviatedNumber = (number / 1000000).toFixed(2);
    const formattedNumber = new Intl.NumberFormat(locale, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(Number(abbreviatedNumber));
    return `${formattedNumber}M`;
  } else if (Math.abs(number) >= 100000) {
    const abbreviatedNumber = (number / 1000).toFixed(2);
    const formattedNumber = new Intl.NumberFormat(locale, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(Number(abbreviatedNumber));

    return `${formattedNumber}K`;
  }

  return new Intl.NumberFormat(locale).format(number.toFixed(decimals));
};

export const currencyFormatter = (
  number = 0,
  locale = window.locale?.defaultLocale,
  decimals = 2,
  roundingRule = DEFAULT_ROUNDING_MODE
) => {
  let roundedNumber = roundingRule(number);
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    style: "currency",
    currency: window.locale?.defaultCurrency ?? "INR",
  }).format(roundedNumber);
};

// Function to get the current year
export const getCurrentYear = () => {
  return new Date().getFullYear();
};

// Function to get the previous month in the "Apr" format
export const getPreviousMonth = () => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const today = new Date();
  const previousMonthIndex = today.getMonth() - 1 < 0 ? 11 : today.getMonth() - 1;
  return months[previousMonthIndex];
};
// Function to get the current month in the "Apr" format
export const getCurrentMonthAbbreviated = () => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const today = new Date();
  const currentMonthIndex = today.getMonth();
  return months[currentMonthIndex];
};
// Function to get the current month in the "1, 2, ..." format
export const getCurrentMonthNumeric = () => {
  const today = new Date();
  const currentMonthIndex = today.getMonth();
  return currentMonthIndex + 1;
};
// Function to get the previous month in the "1, 2, ..." format
export const getPreviousMonthNumeric = () => {
  const today = new Date();
  const currentMonthIndex = today.getMonth();
  return currentMonthIndex;
};
